import React from 'react';
import '../../styles/skeleton.css';

export function StatCardSkeleton({ variant = 'icon' }) {
  if (variant === 'stacked') {
    return (
      <div className="skeleton-stat-card skeleton-stat-card--stacked skeleton-pulse">
        <div className="skeleton-bar skeleton-bar--stat-value skeleton-pulse" />
        <div className="skeleton-bar skeleton-bar--stat-label skeleton-pulse" />
        <div className="skeleton-bar skeleton-bar--stat-sub skeleton-pulse" />
      </div>
    );
  }

  return (
    <div className="skeleton-stat-card skeleton-stat-card--icon skeleton-pulse">
      <div className="skeleton-stat-text-group">
        <div className="skeleton-bar skeleton-bar--value skeleton-pulse" />
        <div className="skeleton-bar skeleton-bar--title skeleton-pulse" />
      </div>
      <div className="skeleton-stat-icon skeleton-pulse" />
    </div>
  );
}

export function StatRowSkeleton({ count = 4, variant = 'icon', className = '' }) {
  return (
    <div className={`skeleton-stat-row ${className}`.trim()}>
      {Array.from({ length: count }).map((_, index) => (
        <StatCardSkeleton key={index} variant={variant} />
      ))}
    </div>
  );
}

export function SkeletonChart({ height = 340, className = 'skeleton-section' }) {
  return (
    <div className={className}>
      <div className="skeleton-bar skeleton-section-title skeleton-pulse" />
      <div className="skeleton-chart-block skeleton-pulse" style={{ height }} />
    </div>
  );
}

export function AnalyticsPageSkeleton() {
  return (
    <>
      <div className="skeleton-date-card">
        <div className="skeleton-bar skeleton-date-title skeleton-pulse" />
        <div className="skeleton-bar skeleton-date-desc skeleton-pulse" />
        <div className="skeleton-date-row">
          <div className="skeleton-date-field">
            <div className="skeleton-bar skeleton-date-label skeleton-pulse" />
            <div className="skeleton-bar skeleton-date-input skeleton-pulse" />
          </div>
          <div className="skeleton-date-field">
            <div className="skeleton-bar skeleton-date-label skeleton-pulse" />
            <div className="skeleton-bar skeleton-date-input skeleton-pulse" />
          </div>
          <div className="skeleton-bar skeleton-date-btn skeleton-pulse" />
          <div className="skeleton-bar skeleton-date-btn skeleton-pulse" />
        </div>
      </div>

      <StatRowSkeleton count={4} variant="stacked" className="skeleton-stat-row--analytics" />
      <SkeletonChart height={340} />
    </>
  );
}
